import React from 'react';
import { useStepHeader } from './StepHeader.hooks';
import {
  StepHeaderContainer,
  StepHeaderBorder,
  StepHeaderIcon,
  StepHeaderTitle,
  StepHeaderDescription,
} from './StepHeader.styles';

export interface StepHeaderProps {
  currentStep: number;
  totalSteps?: number;
  variant?: 'default' | 'small' | 'large';
  showDescription?: boolean;
  className?: string;
}

const StepHeader: React.FC<StepHeaderProps> = ({
  currentStep,
  totalSteps = 3,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  variant = 'default',
  showDescription = false,
  className,
}) => {
  const { currentStepConfig, isValidStep, getStepClasses } = useStepHeader({
    currentStep,
    totalSteps,
  });

  // Si el paso actual no es válido, no renderizar nada
  if (!isValidStep || !currentStepConfig) {
    return null;
  }

  const classes = getStepClasses();

  return (
    <StepHeaderContainer className={`${classes.container} ${className}`}>
      <StepHeaderBorder className={classes.border} />

      <StepHeaderIcon className={classes.icon}>{currentStepConfig.icon}</StepHeaderIcon>

      <div>
        <StepHeaderTitle className={classes.title}>{currentStepConfig.title}</StepHeaderTitle>

        {showDescription && currentStepConfig.description && (
          <StepHeaderDescription>{currentStepConfig.description}</StepHeaderDescription>
        )}
      </div>
    </StepHeaderContainer>
  );
};

export default StepHeader;
